export default "__VITE_ASSET__CeUZCEFk__"